module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg",
    staticStyle: {
      "color": "var(--regpwd-primarytextcolor)"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "splash hiddden",
    attrs: {
      "src": "",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "box-shadow": "2px 2px 10px #ccc"
    },
    attrs: {
      "id": "userRegistration"
    }
  }, [(_vm.tokenInvalid && !_vm.enableRefIdApproach) ? _c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "50px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(0), _vm._v(_vm._s(_vm.user_lang.tokenNotValid) + "\n        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.tokenInvalidInfo))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.enableRefIdApproach && !_vm.tokenInvalid),
      expression: "enableRefIdApproach && !tokenInvalid"
    }],
    staticStyle: {
      "max-width": "800px",
      "margin": "auto",
      "padding-top": "35px",
      "padding": "50px",
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.copyrefid))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refId),
      expression: "refId"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refId = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('button', {
    staticStyle: {
      "color": "#fff"
    },
    on: {
      "click": function($event) {
        _vm.getTokenAndRedirect(_vm.refId)
      }
    }
  }, [_vm._v("Recover")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.tokenInvalid && !_vm.enableRefIdApproach),
      expression: "!tokenInvalid && !enableRefIdApproach"
    }],
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "title-bar"
  }, [_c('p', {
    staticClass: "welcome",
    staticStyle: {
      "background": "var(--regpwd-topnavbarbg)",
      "text-align": "center",
      "padding": "15px",
      "margin": "0px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.hello) + " " + _vm._s(_vm.firstName))]), _vm._v(" \n            "), _c('span', {
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "font-size": "15px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.welcome_cargill) + " " + _vm._s(_vm.brand))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.passwordreset && !_vm.accountunlocked),
      expression: "!passwordreset && !accountunlocked"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "color": "#a7a7a7",
      "margin-top": "10px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code_rule))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticClass: "m-form verify-code-form clearfix leave-open-on-success",
    staticStyle: {
      "padding": "0px 15px",
      "margin": "0px -15px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.edit.form"
    }
  }, [_c('input', {
    staticClass: "hide",
    attrs: {
      "type": "hidden",
      "name": "_xsrfToken",
      "value": "bd39219af46c391c0ea3df7053f999588ed2ca5a8553eaf83a32d4d3f063915f"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "smsFactor",
      "value": "true"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "hide",
    attrs: {
      "name": "activateFactor",
      "value": "false",
      "type": "hidden"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "margin-btm-0",
    staticStyle: {
      "display": "block",
      "margin-top": "20px"
    },
    attrs: {
      "id": "smsPhoneCodeForm.code.label",
      "for": "verifyCode",
      "path": "token",
      "csserrorclass": "error"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.enter_code))]), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifycode),
      expression: "verifycode"
    }],
    staticClass: "verify-code",
    staticStyle: {
      "visibility": "inherit",
      "position": "inherit",
      "width": "100%",
      "display": "inline-block !important",
      "padding-top": "0px"
    },
    attrs: {
      "id": "verifyCode",
      "name": "code",
      "type": "text",
      "value": "",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.verifycode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifycode = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "float": "right"
    }
  }, [_c('input', {
    staticClass: "ajax-form-submit verify-code save button",
    staticStyle: {
      "visibility": "inherit",
      "position": "inherit",
      "color": "var(--regpwd-secondarytextcolor)",
      "border": "1px solid rgb(195, 195, 195)",
      "display": "inline-block !important",
      "font-size": "13px",
      "border-radius": "3px",
      "margin-bottom": "20px",
      "max-width": "120px",
      "padding": "8px 16px"
    },
    attrs: {
      "value": _vm.user_lang.verify,
      "name": "m-save",
      "type": "button",
      "id": "smsPhoneCodeForm.button.submit"
    },
    on: {
      "click": function($event) {
        _vm.verifyResendCode()
      }
    }
  }), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "background": "#f9f9f9",
      "color": "var(--regpwd-secondarytextcolor)",
      "border": "1px solid #c3c3c3",
      "font-size": "13px",
      "display": "inline-block !important",
      "margin-top": "6px",
      "height": "35px",
      "line-height": "14px",
      "max-width": "120px",
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.forgotSQA()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.back))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.codeSent),
      expression: "codeSent"
    }],
    staticStyle: {
      "background": "#f9f9f9",
      "color": "var(--regpwd-secondarytextcolor)",
      "border": "1px solid #c3c3c3",
      "font-size": "13px",
      "display": "inline-block !important",
      "margin-top": "6px",
      "height": "35px",
      "line-height": "14px",
      "max-width": "120px",
      "margin-bottom": "10px"
    },
    on: {
      "click": function($event) {
        _vm.goBack()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.retry))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iserror),
      expression: "iserror"
    }],
    attrs: {
      "id": "smsPhoneCodeForm.edit.errors"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(1), _vm._v(_vm._s(_vm.user_lang.passcodeNotValid) + "\n                    ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.error30SecOTP == true),
      expression: "error30SecOTP == true"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(2), _vm._v(_vm._s(_vm.user_lang.OTPEnableAfter30Sec) + "\n                  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptypasscode == true),
      expression: "emptypasscode == true"
    }],
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._m(3), _vm._v(_vm._s(_vm.user_lang.emptypasscode) + "\n                  ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showResetQA && !_vm.codeSent),
      expression: "showResetQA && !codeSent"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-bottom": "20px",
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.choose_forgot_pwd_qtn))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSecQN),
      expression: "selectedSecQN"
    }],
    staticStyle: {
      "width": "100%"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSecQN = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('optgroup', {
    attrs: {
      "label": _vm.user_lang.stock_qtn
    }
  }, _vm._l((_vm.listofsecquestions), function(sq) {
    return _c('option', {
      domProps: {
        "value": sq.question
      }
    }, [_vm._v(_vm._s(sq.questionText))])
  })), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": _vm.user_lang.custom_qtn
    }
  }, [_c('option', {
    attrs: {
      "value": "custom"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.own_sec_qtn))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSecQN == 'custom'),
      expression: "selectedSecQN == 'custom'"
    }],
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.custom_qtn))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.custom_question),
      expression: "custom_question"
    }],
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.custom_question)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.custom_question = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.answer))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.answer),
      expression: "answer"
    }],
    staticStyle: {
      "width": "100%"
    },
    domProps: {
      "value": (_vm.answer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.answer = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.newpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.rptpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.repeatPwdValidationObj), function(j) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(j))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCode != ''),
      expression: "errorCode != ''"
    }],
    staticStyle: {
      "display": "flex",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "left",
      "padding-top": "0px",
      "background": "#d2d2d2",
      "margin-top": "15px !important"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang[_vm.errorCode]))])]), _vm._v(" "), _c('div', {
    staticClass: "setup-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn-primary create-acc",
    attrs: {
      "value": _vm.user_lang.create_acc
    },
    on: {
      "click": function($event) {
        _vm.resetPassword()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetSecQA) + "\n                        "), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "padding-left": "10px"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.secQAVerified),
      expression: "secQAVerified"
    }],
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetOktaPwd))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.user_lang.enter_new_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.newpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.pwdValidationObj), function(i) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(i))])
  })), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.repeat_pwd))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.repeatpassword),
      expression: "repeatpassword"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.user_lang.rptpwd,
      "type": "password"
    },
    domProps: {
      "value": (_vm.repeatpassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.repeatpassword = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "errorwrapper"
  }, _vm._l((_vm.repeatPwdValidationObj), function(j) {
    return _c('span', {
      staticClass: "pwderror"
    }, [_vm._v(_vm._s(j))])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errorCode != ''),
      expression: "errorCode != ''"
    }],
    staticStyle: {
      "display": "flex",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "left",
      "padding-top": "0px",
      "background": "#d2d2d2",
      "margin-top": "15px !important"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#333",
      "margin-left": "20px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang[_vm.errorCode]))])]), _vm._v(" "), _c('div', {
    staticClass: "setup-section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('button', {
    staticClass: "btn-primary create-acc",
    attrs: {
      "value": _vm.user_lang.create_acc
    },
    on: {
      "click": function($event) {
        _vm.resetPasswordWithoutQAReset()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.user_lang.resetpwd)), _c('i', {
    staticClass: "fa fa-chevron-right",
    staticStyle: {
      "color": "var(--regpwd-secondarytextcolor)",
      "padding-left": "10px"
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.passwordreset),
      expression: "passwordreset"
    }],
    attrs: {
      "id": "congrats"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.passwordreset) + "\n                  "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.passwordresetsuccess))])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.regApps.length !== 0),
      expression: "regApps.length !== 0"
    }],
    staticStyle: {
      "font-size": "16px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.gotoapp) + "\n                ")]), _vm._v(" "), _vm._l((_vm.regApps), function(i) {
    return _c('div', {
      staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-6 regapps",
      attrs: {
        "title": i.label
      },
      on: {
        "click": function($event) {
          _vm.goToApp(i.name.toLowerCase() === 'bookmark' ? i.settings.app.url : i._links.appLinks[0].href)
        }
      }
    }, [_c('div', {
      staticClass: "icon-wrap"
    }, [_c('img', {
      staticStyle: {
        "max-width": "90px"
      },
      attrs: {
        "src": i._links.logo[0].href
      }
    })]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(i.label))])])
  })], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountunlocked),
      expression: "accountunlocked"
    }],
    attrs: {
      "id": "unlocked"
    }
  }, [_c('div', {
    staticClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticStyle: {
      "max-width": "800px",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "setup-section col-lg-12 col-md-12 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "22px",
      "width": "80%",
      "display": "inline-block",
      "margin-bottom": "10px",
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.accountunlocked) + "\n                  "), _c('div', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.unlockaccountsuccess))])]), _vm._v(" "), _vm._m(7)])])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto",
      "display": "inline-block",
      "margin-right": "10px"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#e34843",
      "width": "22px",
      "height": "auto"
    }
  }, [_c('span', {
    staticClass: "exclamatory-error-icon"
  }, [_vm._v("!")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block",
      "width": "20%",
      "float": "right"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px",
      "color": "var(--theme-primary)"
    }
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-f5e219ce", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f5e219ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/ResetPassword.vue
// module id = 723
// module chunks = 1